import { ReportPost, ReportPostFilters, QueryResult } from '@/type';
import api from '@/API';

export default {
  findAll(reportId: number, filters?: ReportPostFilters): Promise<QueryResult> {
    return api
      .get(`reports/${reportId}/posts`, { params: filters })
      .then(response => response.data);
  },
};
